// extracted by mini-css-extract-plugin
module.exports = {"button":"UserRoleChange-button-b514e243ef079f508eebac36a7ee6ed9"};